import { render, staticRenderFns } from "./HeaderSider.vue?vue&type=template&id=027df556&scoped=true&"
import script from "./HeaderSider.vue?vue&type=script&lang=js&"
export * from "./HeaderSider.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSider.vue?vue&type=style&index=0&id=027df556&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027df556",
  null
  
)

export default component.exports